<template>
  <div>
    <h1 class="mdn-Heading mdn-Heading--sm">Gerenciamento de Grupos</h1>

    <SGPBotaoAdicionarNovoComponent @sgpAdiconarNovoEmit="adicionarNovoGrupo" />

    <SGPTabelaComponent
      v-if="listaDeGrupos.length"
      :colunas="colunas"
      :dados="listaDeGrupos"
      @sgpTabelaLinhasSelecionadasEmit="gerenciadorDeSelecionados"
      @sgpTabelaEditarSelecionadoEmit="editarSelecionado"
      @sgpTabelaDeletarSelecionadoEmit="deletarSelecionado"
    ></SGPTabelaComponent>

    <SGPAlertaComponent v-else></SGPAlertaComponent>

    <SGPModalComponent
      v-if="abrirModal"
      tamanho="sm"
      titulo="Cadastro de Grupo"
      @sgpModalFechar="fecharModal"
      :mostrarFooter="false"
    >
      <FormularioGrupoComponent
        :tipoFormulario="tipoFormulario"
        :grupo="grupo"
      />
    </SGPModalComponent>

    <SGPConfirmacaoDelecaoComponent
      v-if="deletarDados"
      @sgpCancelarDelecaoEmit="cancelarDelecao()"
      @sgpConfirmarDelecaoEmit="confirmarDelecao()"
    />

    <SGPLoadingComponent v-if="loadingGrupos"/>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import FormularioGrupoComponent from '../components/FormularioGrupoComponent.vue'

export default {
  components: { FormularioGrupoComponent },
  name: 'GruposPage',

  data () {
    return {
      mostrarSelecionar: true,
      mostrarEditar: true,
      mostrarDeletar: true,
      gruposSelecionados: [],
      abrirModal: false,
      deletarDados: false,
      tipoFormulario: 'salvar',
      grupo: {}
    }
  },
  created () {
    this.listarGrupos();
  },
  computed: {
    ...mapGetters('grupos', ['listaDeGrupos', 'loadingGrupos']),
    
    colunas () {
      return [
        {
          key: 'selecionar',
          label: '',
          sortable: false
        },
        {
          key: 'grupo',
          label: 'Grupo',
          sortable: false
        },
        {
          key: 'descricao',
          label: 'Descrição',
          sortable: false
        },
      ]
    }
  },

  methods: {
    ...mapActions('grupos', ['listarGrupos','excluirGrupos']),

    gerenciadorDeSelecionados (selecionados) {
      this.gruposSelecionados = selecionados;
    },

    editarSelecionado () {
      this.tipoFormulario = 'editar';
      this.grupo = this.gruposSelecionados[0];
      this.abrirModal = true;
    },

    deletarSelecionado () {
      this.deletarDados = true;
    },

    cancelarDelecao () {
      this.deletarDados = false;
    },

    confirmarDelecao () {
      this.excluirGrupos(this.gruposSelecionados);
      this.deletarDados = false;
    },

    adicionarNovoGrupo () {
      this.grupo = {};
      this.tipoFormulario = 'salvar';
      this.abrirModal = true;
    },

    fecharModal () {
      this.abrirModal = false;
    }

  }
}
</script>
